const ALLOWED_REGIMENES = new Set(["601", "612", "621", "626"]);

export class MXInvoiceValidation {

  constructor(dom, payment, formattedPaymentAmount) {
    this.dom = dom;
    this.payment = payment;
    this.formattedPaymentAmount = formattedPaymentAmount;
  }

  validate() {
    console.log("=> Mexican Invoice : ", this.dom.documentElement.nodeName);

    return this._validateInvoice();
  }

  receiptType() {
    return "invoice";
  }

  get emisor() {
    const tags = this.dom.documentElement.getElementsByTagName("cfdi:Emisor");

    if (tags.length > 0) {
      return tags[0];
    } else {
      return undefined;
    }
  }

  get fiscalID() {
    if (this.emisor) {
      return this.emisor.getAttribute("Rfc");
    } else {
      return undefined;
    }
  }

  get regimenFiscal() {
    if (this.emisor) {
      return this.emisor.getAttribute("RegimenFiscal");
    } else {
      return undefined;
    }
  }

  get fitpassFiscalID() {
    const tags = this.dom.documentElement.getElementsByTagName("cfdi:Receptor");

    if (tags.length > 0) {
      return tags[0].getAttribute("Rfc");
    } else {
      return undefined;
    }
  }

  get fitpassZipCode() {
    const tags = this.dom.documentElement.getElementsByTagName("cfdi:Receptor");

    if (tags.length > 0) {
      return tags[0].getAttribute("DomicilioFiscalReceptor");
    }
  }

  get totalRetenciones() {
    const impuestos = this.dom.documentElement.getElementsByTagName("cfdi:Impuestos");

    for (let i = 0; i < impuestos.length; i++) {
      const total = impuestos[i].getAttribute("TotalImpuestosRetenidos");
      if (total != null) {
        return parseFloat(total);
      }
    }

    const retenciones = this.dom.documentElement.getElementsByTagName("cfdi:Retencion");
    let sum = 0;
    for (let i = 0; i < retenciones.length; i++) {
      const importe = parseFloat(retenciones[i].getAttribute("Importe"));
      if (!isNaN(importe)) {
        sum += importe;
      }
    }
    return sum;
  }

  _validateInvoice() {
    const doc = this.dom.documentElement;
    if (doc == null) {
      return {error: true, message: "Archivo XML inválido, monto de factura no encontrado"};
    }

    if (doc.nodeName !== "cfdi:Comprobante") {
      return {error: true, message: "Archivo XML inválido"};
    }

    if (doc.getAttribute("FormaPago") !== "03") {
      return {error: true, message: "Solo se aceptan facturas con método de pago \"Transferencia electrónica de Fondos\""};
    }

    console.log("Checking Fitpass CP", this.fitpassZipCode);

    if (this.fitpassZipCode !== "11000") {
      return {
        error: true,
        message: `La factura no coincide con nuestro Domicilio Fiscal`
      };
    }

    console.log("Checking Fitpass fiscal ID", this.fitpassFiscalID);

    if (this.fitpassFiscalID !== "FIT151125976") {
      return {
        error: true,
        message: `La factura no coincide con nuestros datos fiscales... Fitpass SAPI de CV, RFC FIT151125976. Favor de revisarlos. Gracias`
      };
    }

    console.log("Checking Fiscal ID", this.fiscalID);
    if (this.fiscalID == null) {
      return {
        error: true,
        message: `Archivo XML inválido, RFC Emisor no encontrado`
      };
    }

    console.log("Checking Regimen Fiscal ", this.regimenFiscal);

    if (!ALLOWED_REGIMENES.has(this.regimenFiscal)) {
      return {
        error: true,
        message: `Régimen Fiscal <b>${this.regimenFiscal}</b> no aceptado. Solo se aceptan facturas con régimen 601, 612, 621 o 626. Favor de revisar con tu contador.`
      };
    }

    const total = parseFloat(doc.getAttribute("Total"));
    const gross = total + this.totalRetenciones;

    console.log("=> Gross (Total + retenciones): ", gross, " Total: ", total, " Retenciones: ", this.totalRetenciones);

    return this.validaAmount(gross);
  }

  /**
   * @param amount number
   * @returns {{error: boolean, message: string}}
   */
  validaAmount(amount) {
    const payment = this.payment;
    const min = Math.trunc(payment) - 2;
    const max = Math.trunc(payment) + 2;
    const truncAmount = Math.trunc(amount);

    console.log("=> Amounts min: ", min, " value: ", truncAmount, " max: ", max);

    const formattedAmount = new Intl.NumberFormat(
      "es-MX",
      {
        style: "currency",
        currency: "MXN",
      }
    ).format(amount);

    if (truncAmount < min || truncAmount > max) {
      return {
        error: true, message: `
        Monto de la factura <b>${formattedAmount}</b> no coincide ,
        les recordamos que el monto total del reporte de visitas Fitpass incluye IVA.
        Para dudas adicionales, favor de enviar correo a contacto@fitpass.mx
      `.trim()
      };
    }

    return {error: false, message: ""};
  }
}
